import { useSignal } from "#/use-signal";
import {
  authLoadingSignal,
  checkAuth,
  connectionErrorSignal,
  login,
  logout,
  userSignal,
  type User,
} from "./auth-store";

export type { User };

/** Thin facade over auth signals + actions (no React context). */
export function useAuth() {
  const user = useSignal(userSignal);
  return {
    user,
    isLoading: useSignal(authLoadingSignal),
    connectionError: useSignal(connectionErrorSignal),
    isAuthenticated: Boolean(user),
    login,
    logout,
    retryAuth: checkAuth,
  };
}
